import { render, staticRenderFns } from "./ReportWrapper.vue?vue&type=template&id=3146c08a&"
import script from "./ReportWrapper.vue?vue&type=script&lang=js&"
export * from "./ReportWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports